import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { alpha, Box, Button, Typography } from "@mui/material";

const mintGradient = "linear-gradient(135deg, #123524 0%, #1f7a4d 100%)";
const mintGradientHover = "linear-gradient(135deg, #0f2d1f 0%, #1a6b42 100%)";

interface MaxServiceAlertProps {
  openInfo: any;
  handleClose: any;
}

const MaxServiceAlert: React.FC<MaxServiceAlertProps> = ({
  openInfo,
  handleClose,
}) => {
  return (
    <React.Fragment>
      <Dialog
        open={openInfo}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        sx={{
          zIndex: 12000,
        }}
        PaperProps={{
          sx: {
            borderRadius: "16px",
            border: `1px solid ${alpha("#1f7a4d", 0.12)}`,
            boxShadow: "0 24px 48px rgba(15, 23, 17, 0.12)",
            overflow: "hidden",
          },
        }}
      >
        <DialogContent sx={{ pt: 3, pb: 2.5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="subtitle1"
              id="alert-dialog-title"
              sx={{
                color: "#92400e",
                fontWeight: 700,
                letterSpacing: "-0.02em",
              }}
            >
              Service limit
            </Typography>
          </Box>
          <Box sx={{ mt: 1.5 }}>
            <Typography variant="body2" sx={{ color: "#1a2e24", lineHeight: 1.6 }}>
              You can add up to 5 exclusive services at once.
              <br />
              <br />
              Choose your ideal services now, and add more whenever you&#39;re
              ready to elevate your experience.
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              mt: 2.5,
            }}
          >
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{
                borderRadius: "999px",
                px: 2.5,
                py: 1,
                textTransform: "none",
                fontWeight: 600,
                background: mintGradient,
                boxShadow: "0 8px 20px rgba(18, 53, 36, 0.2)",
                "&:hover": { background: mintGradientHover },
              }}
            >
              OK
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default MaxServiceAlert;
